import { getLocation } from '#common/ipstack';
import { normalizeState, matchesState, parseStateOptions } from '#common/geo-match';

const componentSelector = '[data-geo-media-duo]';
const itemSelector = '[data-geo-media-duo-item]';
const visibleClass = 'is-geo-visible';
const textTargetSelector = '[data-geo-state-text]';
const placeholder = '{state}';
const stateInjectedAttr = 'data-geo-state-text-injected';

document.addEventListener('DOMContentLoaded', () => {
	const components = document.querySelectorAll(componentSelector);
	if (!components.length) return;

	components.forEach(component => init_component(component));
});

function init_component(component) {
	getLocation()
		.then(location => {
			if (!location || !location.state) return;
			reveal_component(component, location.state);
		})
		.catch(err => {
			console.warn('Unable to resolve IPStack location for media duo.', err);
		});
}

function reveal_component(component, stateName) {
	const normalizedState = normalizeState(stateName);
	if (!normalizedState) return;

	replace_state_tokens(component, stateName);

	let hasMatch = false;
	const items = component.querySelectorAll(itemSelector);

	items.forEach(item => {
		const options = parseStateOptions(item.getAttribute('data-state-options'));
		const matches = matchesState(options, normalizedState);
		set_item_visibility(item, matches);
		if (matches) {
			hasMatch = true;
		}
	});

	set_component_visibility(component, hasMatch);
}

function set_item_visibility(item, isVisible) {
	item.hidden = !isVisible;
	item.classList.toggle(visibleClass, isVisible);
}

function set_component_visibility(component, isVisible) {
	component.hidden = !isVisible;
	component.classList.toggle(visibleClass, isVisible);
}

function replace_state_tokens(component, stateName) {
	if (!component || !stateName) return;

	const targets = component.querySelectorAll(textTargetSelector);
	if (!targets.length) return;

	targets.forEach(target => {
		if (target.getAttribute(stateInjectedAttr) === 'true') {
			return;
		}

		const replaced = replace_tokens_in_node(target, stateName);
		if (replaced) {
			target.setAttribute(stateInjectedAttr, 'true');
		}
	});
}

function replace_tokens_in_node(root, stateName) {
	if (!root || !root.textContent || !root.textContent.includes(placeholder)) {
		return false;
	}

	const textFilter = typeof NodeFilter === 'undefined' ? 4 : NodeFilter.SHOW_TEXT;
	const walker = document.createTreeWalker(root, textFilter, null);
	let replaced = false;

	while (walker.nextNode()) {
		const node = walker.currentNode;
		if (!node.nodeValue || !node.nodeValue.includes(placeholder)) continue;

		node.nodeValue = node.nodeValue.split(placeholder).join(stateName);
		replaced = true;
	}

	return replaced;
}
